import { createElement } from "react";
import { useApp } from "../../../hooks/useApp"
import { getTotalPrice, getMainProductVariantById } from "../../../utils"
import { formatCentsToDollars } from "../../../utils/formatCentsToDollars"
import { Button } from "../../ui/Button/Button"
import { Text } from "../../ui/Text/Text"

export const Header = () => {
  const { 
    mainProduct, 
    activeScreen, 
    setActiveScreen, 
    activeMainProductVariantId, 
    activePendantProductVariantIds, 
    isMainProductSinglePendant
  } = useApp()
  const  { title, metafields: { pdpBiLine } } = mainProduct
  const activeProductVariant = getMainProductVariantById(mainProduct, activeMainProductVariantId)
  const pdpVariantBiLine = activeProductVariant.metafields.pdpBiLine
  const currentProductBiLine = pdpVariantBiLine ? pdpVariantBiLine : pdpBiLine
  const totalPrice = getTotalPrice(mainProduct, activeMainProductVariantId, activePendantProductVariantIds)

  const renderWishlistButton = (className: string) => {
    if (!mainProduct.globalSettings.enableBauCtas) {
      return null
    }

    return createElement('wishlist-button', {
      className,
      product: JSON.stringify(mainProduct),
      'product-bi-line': currentProductBiLine,
      'variant-selected': JSON.stringify(activeProductVariant),
      'variant-selected-id': String(activeProductVariant.id),
      'template-suffix': mainProduct.templateSuffix,
      disabled: 'false',
      'error-message': '',
      'is-show-only-icon': 'true',
      'product-personalised-price': '0'
    })
  }

  return (
    <>
      <header className="absolute left-0 right-0 top-0 flex flex-col gap-1 items-center p-4 xl:hidden">
        <div className="relative flex w-full items-start justify-center">
          <h1 className="text-center">
            <Text className="capitalize" style="h6">{title}</Text>
          </h1>

          <div className="absolute right-0 top-1/2 -translate-y-1/2 leading-none">
            {renderWishlistButton('wishlist-button js-wishlist-button js-scroll-to-position block')}
          </div>
        </div>

        <p className="block mt-[2px] text-subdued text-[12px]">
          {currentProductBiLine}
        </p>

        {isMainProductSinglePendant && (
          <Text className="ProductMeta__Price Price js-product-price text-[13px]">{formatCentsToDollars(totalPrice)}</Text>
        )}

        {!isMainProductSinglePendant && activeScreen === "CHAIN" && (
          <Button className="text-center" onClick={() => setActiveScreen("PENDANTS")}>
            <Text style="button-quaternary-dark">Edit Charms</Text>
          </Button>
        )}

        {!isMainProductSinglePendant && activeScreen === "PENDANTS" && (
          <Button className="text-center" onClick={() => setActiveScreen("CHAIN")}>
            <Text style="button-quaternary-dark">Edit Chain Length</Text>
          </Button>
        )}

      </header>

      <header className="flex flex-col items-start xl-max:hidden">
        <div className="flex w-full items-start justify-between gap-4">
          <h1><Text className="text-[18px] capitalize" style="h4">{title}</Text></h1>
          <div className="shrink-0 leading-none">
            {renderWishlistButton('wishlist-button js-wishlist-button js-scroll-to-position block')}
          </div>
        </div>

        <div className="flex flex-col justify-between gap-2">
          <p className="block mt-XS text-subdued">
            {currentProductBiLine}
          </p>
          <span
            className="ProductMeta__Price Price js-product-price"
            aria-live="polite"
            aria-atomic="true"
          >
            {formatCentsToDollars(totalPrice)}
          </span>
        </div>

        {!isMainProductSinglePendant && activeScreen === "CHAIN" && (
          <Button className="mt-5" onClick={() => setActiveScreen("PENDANTS")}>
            <Text style="button-quaternary-dark">Edit Charms</Text>
          </Button> 
        )}

        {!isMainProductSinglePendant && activeScreen === "PENDANTS" && (
          <Button className="mt-5" onClick={() => setActiveScreen("CHAIN")}>
            <Text style="button-quaternary-dark">Edit Chain Length</Text>
          </Button>
        )}
      </header>
    </>
  )
}